import { Logic, Operator } from 'core-components/types'

import { getJBPPartnerBasicInfoCrudWithKey } from './helpers/getJBPPartnerBasicInfoCrudWithKey'
import { IJBPPartnerBasicInfoCrudParams } from './models'

export interface IFetchPartnerInfoParams extends IJBPPartnerBasicInfoCrudParams {
  skipHierarchyFilter?: boolean
  force?: boolean
}

export const fetchPartner360Configuration = async ({
  skipHierarchyFilter = false,
  force = false,
  ...crudParams
}: IFetchPartnerInfoParams) => {
  const crud = getJBPPartnerBasicInfoCrudWithKey(crudParams.partnerId, crudParams.fYear)

  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerID',
        operator: Operator.EQUAL,
        value: crudParams.partnerId,
      },
      {
        field: 'FYear',
        operator: Operator.EQUAL,
        value: crudParams.fYear,
      },
    ],
  })

  const response = await crud.fetch({ skipHierarchyFilter, force })

  if (!response.items.length) {
    crud.removeQueries()
    throw new Error('No data provided')
  }

  return response.items[0]
}
